import * as actions from "../actions/slidesActions"

const initialState = {
    loading: false
};

export const slidesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SEND_CONVERT_TO_SLIDES_REQUEST:
        case actions.SEND_CONFIRM_TO_SLIDES_REQUEST:
            return {
                ...state,
                loading: true
            };

        case actions.SEND_CONVERT_TO_SLIDES_REQUEST_SUCCESS:
        case actions.SEND_CONVERT_TO_SLIDES_REQUEST_FAILURE:
        case actions.SEND_CONFIRM_TO_SLIDES_REQUEST_SUCCESS:
        case actions.SEND_CONFIRM_TO_SLIDES_REQUEST_FAILURE:
            return {
                ...state,
                loading: false
            };

        default:
            return state
    }
};
